const { gon = {} } = window;

export default gon;
